/**
 * Format a prompt's date for display.
 * Current year: "30th Jan"
 * Other years: "30th Jan 2024"
 * @param {string|Date} date - ISO date string or Date object
 * @returns {string} Formatted date string
 */
export function formatPromptDate(date) {
  if (!date) return '';
  const d = typeof date === 'string' ? new Date(date) : date;
  if (Number.isNaN(d.getTime())) return '';

  const day = d.getDate();
  const month = d.toLocaleString('en-GB', { month: 'short' });
  const year = d.getFullYear();
  const currentYear = new Date().getFullYear();

  const ordinal = (n) => {
    const v = n % 100;
    if (v >= 11 && v <= 13) return `${n}th`;
    const s = ['th', 'st', 'nd', 'rd'];
    return `${n}${s[n % 10] || 'th'}`;
  };

  return currentYear === year
    ? `${ordinal(day)} ${month}`
    : `${ordinal(day)} ${month} ${year}`;
}
